export enum MenuUrlEnum {
  BaseUrl = "/",
  Login = "/login",
  Logout = "/logout",
  PasswordRecover = "/password-recover",
  EmailApproveReject = "/email/:approveOrReject/:eventKey/:uidKey",
  DashboardPrecatorios = "/dashboard/precatorios",
  DashboardTrades = "/dashboard/trades",
  DashboardEfficiency = "/dashboard/efficiency",
  DashboardDiligence = "/dashboard/diligence",
  DashboardLateTickets = "/dashboard/late-tickets",
  DashboardLateTrades = "/dashboard/late-trades",
  DashboardRejectedTrades = "/dashboard/rejected-trades",
  DashboardPendencyTrades = "/dashboard/pendency-trades",
  ExpensesPending = "/expense/pending",
  ExpensesJuridicalPending = "/expense/juridical-pending",
  ExpensesApproved = "/expense/approved",
  OcrPending = "/expense/ocr-pending",
  ExpensesScheduled = "/expense/scheduled/manually", // XISJUSTE - Alterar Alterar para ExpensesManuallyScheduled
  ExpensesAutomaticallyScheduled = "/expense/scheduled/automatically",
  ExpensesAutomaticallyCanceled = "/expense/canceled/automatically",
  ExpensesPaid = "/expense/paid",
  ExpensesInReview = "/expense/in-review",
  ExpensesRejected = "/expense/rejected",
  WfPreCartorio = "/workflow/pre-cartorio",
  WfDigitalCertificate = "/workflow/view-digital-certificate",
  WfCartorio = "/workflow/cartorio",
  WfDisbursementPendencies = "/workflow/disbursement-pendencies",
  WfValidSpecialProject = "/workflow/special-project/valid-trade",
  WfApprovedSpecialProject = "/workflow/special-project/approved-trade",
  WfPending = "/workflow/pending",
  WfPendingSent = "/workflow/pending-sent",
  WfPricing = "/workflow/pricing",
  WfPricingEdit = "/workflow/pricing/:id",
  WfContractInformation = "/workflow/contract-information",
  WfDocumentValidation = "/workflow/document-validation",
  WfDocumentApproval = "/workflow/document-approval",
  WfLegalCertificates = "/workflow/legal-certificates",
  WfAcceptanceTerm = "/workflow/acceptance-term",
  WfFraud = "/workflow/fraud",
  WfPreFraud = "/workflow/pre-fraud",
  WfCompliance = "/workflow/compliance",
  WfCredit = "/workflow/credit-validation",
  WfApprovalCourt = "/workflow/approval-court",
  WfDiligence = "/workflow/diligence",
  WfPreSpecialSituation = "/workflow/pre-special-situation",
  WfSpecialSituation = "/workflow/special-situation",
  WfDuplicationCheck = "/workflow/duplication-check",
  WfAnalysis = "/workflow/analysis",
  WfCessionTerm = "/workflow/cession-term",
  WfAttorney = "/workflow/attorney",
  WfPreDisbursement = "/workflow/pre-disbursement",
  WfDisbursement = "/workflow/disbursement",
  WfPostPurchase = "/workflow/post-purchase",
  WfRejected = "/workflow/rejected",
  WfArchived = "/workflow/archived",
  WfPendency = "/workflow/pendency",
  WfAnalysisEstateInventory = "/workflow/estate-inventory/analysis",
  WfEstateInventory = "/workflow/estate-inventory",
  WfLawFirmApproveEstateInventory = "/workflow/estate-inventory/law-firm-approve",
  ReconcileSettlements = "/settlements/reconcile",
  UnreconcileSettlements = "/settlements/unreconcile",
  NegativeSpreadSettlements = "/settlements/negative-spread",
  DebtRollover = "/settlements/debt-rollover",
  ComissionReport = "/settlements/comission-report",
  DebtRolloverDashBoard = "/settlements/dashboard",
  ToolsListCampaign = "/tools/list-campaign",
  ToolsRegisterCampaignNew = "/tools/register-campaign/new",
  ToolsRegisterCampaignEdit = "/tools/register-campaign/:id",
  ToolsCalculatorDap = "/tools/calculator/calculator-dap",
  ToolsCalculatorManual = "/tools/calculator/calculator-manual",
  ToolsMonitoringOfficer = "/tools/monitoring/officers",
  ToolsMonitoringMigalhas = "/tools/monitoring/migalhas",
  ToolsMonitoringTrades = "/tools/monitoring/trades",
  ToolsBigDataCorp = "/tools/bigdatacorp",
  ToolsPrecificacaoLote = "/tools/precificacao-lote",
  ToolsDetalhePrecificacao = "/tools/precificacao-lote/:id",
  ToolsBCheckBatch = "/tools/bcheck-batch",
  ToolsDetailBCheckBatch = "/tools/bcheck-batch/:id",
  ToolsValorExposicaoLote = "/tools/valor-exposicao-lote",
  ToolsValorExposicaoLoteDetail = "/tools/valor-exposicao-lote/:id",
  EntubaPricing = "/entuba/pricing",
  EntubaPricingDetail = "/entuba/pricing/:id",
  EntubaBCheck = "/entuba/bcheck",
  EntubaBCheckDetail = "/entuba/bcheck/:id",

  PrePrecatorioDetail = "/entuba/pre-precatorio/:id",
  PrePrecatorios = "/entuba/pre-precatorio/",

  EntubaPan = "/entuba/pan",
  EntubaPanDetail = "/entuba/pan/:id",
  EntubaTradeBatch = "/entuba/trade-batch",
  EntubaTradeBatchDetail = "/entuba/trade-batch/:id",
  EntubaOriginationBatch = "/entuba/origination-batch",
  EntubaOriginationBatchDetail = "/entuba/origination-batch/:id",
  EntubaExpenseBatch = "/entuba/expense-batch",
  EntubaExpenseBatchDetail = "/entuba/expense-batch/:id",
  EntubaFeePaymentBatch = "/entuba/fee-payment-batch",
  EntubaFeePaymentBatchDetail = "/entuba/fee-payment-batch/:id",
  EntubaReconcileSettlementBatch = "/entuba/reconcile-settlement-batch",
  EntubaReconcileSettlementBatchDetail = "/entuba/reconcile-settlement-batch/:id",
  EntubaToggleAccrualBatch = "/entuba/toggle-accrual-batch",
  EntubaToggleAccrualBatchDetail = "/entuba/toggle-accrual-batch/:id",
  EntubaAdditiveBatch = "/entuba/additive-batch",
  EntubaAdditiveBatchDetail = "/entuba/additive-batch/:id",
  ManagerCartorioNew = "/manager/cartorio/new",
  ManagerCartorioEdit = "/manager/cartorio/:id",
  ManagerCartorio = "/manager/cartorio",
  ManagerCartorioList = "/manager/cartorio/list",
  ManagerCommonDomain = "/manager/common-domain",
  ManagerProfiles = "/manager/profiles",
  ManagerProfilesEdit = "/manager/profiles/:id",
  ManagerProfilesNew = "/manager/profiles/new",
  ManagerRules = "/manager/rules",
  ManagerRulesEdit = "/manager/rules/:id",
  ManagerRulesNew = "/manager/rules/new",
  ManagerResources = "/manager/resources",
  ManagerResourcesEdit = "/manager/Resources/:id",
  ManagerResourcesNew = "/manager/Resources/new",
  ManagerUser = "/manager/users",
  ManagerUserEdit = "/manager/users/:id",
  ManagerUserNew = "/manager/users/new",
  ManagerFiles = "/manager/files",
  ManagerOfficers = "/manager/officers",
  ManagerOfficersEdit = "/manager/officers/:id",
  ManagerOfficersNew = "/manager/officers/new",
  ManagerLawFirmList = "/manager/law-firm/list",
  ManagerLawFirmNew = "/manager/law-firm/new",
  ManagerLawFirmEdit = "/manager/law-firm/:id",
  ManagerLawFirm = "/manager/law-firm",
  ManagerTicketControlGrid = "/manager/ticket/controlgrid",
  ManagerSpecialProject = "/manager/special-project",
  ManagerSpecialProjectEdit = "/manager/special-project/:id",
  ManagerSpecialProjectNew = "/manager/special-project/new",
  ManagerEmailsBoilerplates = "/manager/emails/boilerplates",
  ManagerEmailsBoilerplatesEdit = "/manager/emails/boilerplates/:id",
  ManagerEmailsBoilerplatesNew = "/manager/emails/boilerplates/new",
  ManagerEmailsTemplates = "/manager/emails/templates",
  ManagerEmailsTemplatesEdit = "/manager/emails/templates/:id",
  ManagerEmailsTemplatesNew = "/manager/emails/templates/new",
  ManagerEmailsMounted = "/manager/emails/mounted",
  ManagerEmailsMountedEdit = "/manager/emails/mounted/:id",
  ManagerEmailsMountedNew = "/manager/emails/mounted/new",
  ManagerEmailsTestes = "/manager/emails/testes",
  ManagerStrategy = "/manager/strategy",
  ManagerStrategyEdit = "/manager/strategy/:id",
  ManagerStrategyNew = "/manager/strategy/new",
  ManagerBlackList = "/manager/black-list",
  ManagerBlackListEdit = "/manager/black-list/:id",
  ManagerBlackListNew = "/manager/black-list/new",
  ManagerCourt = "/manager/court",
  ManagerCourtEdit = "/manager/court/:id",
  ManagerCourtNew = "/manager/court/new",
  ManagerExpenseCategory = "/manager/expense-category",
  ManagerExpenseCategoryNew = "/manager/expense-category/new",
  ManagerExpenseCategoryEdit = "/manager/expense-category/:id",
  ManagerFidc = "/manager/fidc",
  ManagerFidcEdit = "/manager/fidc/:id",
  ManagerFidcNew = "/manager/fidc/new",


  ConfigurationCourtTypeNew = "/configuration/court-type/new",
  ConfigurationCourtTypeEdit = "/configuration/court-type/:id",
  ConfigurationCourtType = "/configuration/court-type",
  ConfigurationCourtTypeList = "/configuration/court-type/list",
  ConfigurationCourtNew = "/configuration/court/new",
  ConfigurationCourtEdit = "/configuration/court/:id",
  ConfigurationCourt = "/configuration/court",
  ConfigurationCourtList = "/configuration/court/list",
  ConfigurationCourtExpectedPaymentNew = "/configuration/court-expected-payment/new",
  ConfigurationCourtExpectedPaymentEdit = "/configuration/court-expected-payment/:id",
  ConfigurationCourtExpectedPayment = "/configuration/court-expected-payment",
  ConfigurationCourtExpectedPaymentList = "/configuration/court-expected-payment/list",
  ConfigurationSpreadNew = "/configuration/spread/new",
  ConfigurationSpreadEdit = "/configuration/spread/:id",
  ConfigurationSpread = "/configuration/spread",
  ConfigurationSpreadList = "/configuration/spread/list",

  BlockedTrades = "/report/blocked-trades",
  ReportExposure = "/report/exposure",
  ReportPostPurchase = "/report/post-purchase",
  ReportPostPurchaseStatus = "/report/post-purchase/status",
  ReportPostPurchaseAcquired = "/report/post-purchase/acquired",
  ReportPostPurchaseMovement = "/report/post-purchase/movement",
  ReportPostPurchaseHistorySource = "/report/post-purchase/history/source",
  ReportPostPurchaseHistoryType = "/report/post-purchase/history/type",
  ReportPaidExpenses = "/report/paid-expenses",
  ReportReDueDiligence = "/report/due-diligence",

  ContingencyCorretionTable = "/contingency/correction-table",
  ContingencyMaintenanceTrade = "/contingency/trade-update",

  WfDataSendDeals = "/workflow/deal/data-send",
  WfDiligenceDeals = "/workflow/deal/diligence",
  WfAnalysisDeals = "/workflow/deal/analysis",

  FIDCEntuba = "/wholesale/entuba",
  FIDCEntubaDetail = "/wholesale/entuba/:id",

}
